import { render } from "./MyQuote.vue?vue&type=template&id=11ce89fa&scoped=true"
import script from "./MyQuote.vue?vue&type=script&lang=ts"
export * from "./MyQuote.vue?vue&type=script&lang=ts"

import "./MyQuote.vue?vue&type=style&index=0&id=11ce89fa&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-11ce89fa"

export default script